<div>
  @if (computedResultFocus() === 'contact-focused') {
    <!-- Contact-focused: Kontakt ist Hauptentity, Projekte untergeordnet -->
    <div class="work-card padding-narrow margin-12 flex flex-column gap-8">
      <!--CONTACT-->
      @if (contactAndProjects().contact) {
        <ng-container [ngTemplateOutlet]="contactResult" [ngTemplateOutletContext]="{contactFocused: true}" />
      }
      <!--PROJEKTE-->
      @if (contactAndProjects().projects && contactAndProjects().projects.length) {
        <div class="flex flex-column gap-4">
          @for (project of contactAndProjects().projects; track project.id) {
            <ng-container [ngTemplateOutlet]="projectOutlet"
                          [ngTemplateOutletContext]="{project: project}"></ng-container>
          }
        </div>
      }
      <!--RESULTAT GEFUNDEN IN-->
      @if (contactAndProjects().foundInProperty && contactAndProjects().foundInProperty.length > 1) {
        <ng-container [ngTemplateOutlet]="foundInTemplate"></ng-container>
      }
    </div>
  } @else {
    <!-- Project-focused: Projekte sind Hauptentities, Kontakt untergeordnet -->
    @for (project of uniqueProjects(); track project.id) {
      <div class="work-card padding-narrow margin-12 flex flex-column gap-8">
        <!--PROJECT-->
        <ng-container [ngTemplateOutlet]="projectOutlet" [ngTemplateOutletContext]="{project: project}"></ng-container>

        <!--CONTACT-->
        @if (contactAndProjects().contact) {
          <ng-container [ngTemplateOutlet]="contactResult" />
        }

        <!--RESULTAT GEFUNDEN IN-->
        @if (contactAndProjects().foundInProperty && contactAndProjects().foundInProperty.length > 1) {
          <ng-container [ngTemplateOutlet]="foundInTemplate"></ng-container>
        }
      </div>
    }
  }
</div>


<!--REUSABLE NG-TEMPLATES FOR BOTH VARIANTS: PROJECT-->
<ng-template #projectOutlet let-project="project">
  <div class="flex flex-column flex-row--desktop vertical-center gap-8 work-action-element"
       [class.disabled]="disableResultProjectLinks()"
       [routerLink]="renderProjectAsLink() ? '/'+AppRoutePaths.PROJEKTE+'/'+AppRouteViewTypes.DETAILS+'/' + project.id : undefined"
       (click)="projectClicked.emit({WorkContactAndProjectsResultDto: contactAndProjects(), selectedProject: project})"
       (keydown.enter)="projectClicked.emit({WorkContactAndProjectsResultDto: contactAndProjects(), selectedProject: project})"
       tabindex="0">
    <p class="flex flex-row vertical-center gap-8">
      <strong [innerHTML]="project?.numberQualified || '-' | highlight:searchterm()" class="work-text-no-wrap"></strong>
    </p>
    <p>
      @if (!project.hasEqualObjectAddress) {
        <p class="flex flex-row gap-4 wrap">
          <span class="work-text-color-light"
                [innerHTML]="project.objectStreet + ', ' | highlight:searchterm()"></span>
          <span class="work-text-color-light"
                [innerHTML]="project.objectZip | highlight:searchterm()"></span>
          <span class="work-text-color-light"
                [innerHTML]="project.objectCity | highlight:searchterm()"></span>
        </p>
      } @else {
        <p class="flex flex-row gap-4 wrap">
          <span class="work-text-color-light"
                [innerHTML]="contactAndProjects().contact.street + ', ' | highlight:searchterm()"></span>
          <span class="work-text-color-light"
                [innerHTML]="contactAndProjects().contact.zipcode | highlight:searchterm()"></span>
          <span class="work-text-color-light"
                [innerHTML]="contactAndProjects().contact.city | highlight:searchterm()"></span>
        </p>
      }
    </p>
    <!-- Kunde/Projektnummer beim Partner-Mandanten (z. B. der Axova-Kunde bei SFG) — erklärt Treffer über diese Angaben. -->
    @for (projectLink of project.tenantProjectLinks; track projectLink.id) {
      @if (projectLink.externalCustomerName || projectLink.externalProjectNumber) {
        <p class="flex flex-row gap-4 wrap">
          <small class="work-text-color-light">{{ projectLink.tenant?.name || ('externalCustomerName' | translate) }}:</small>
          @if (projectLink.externalCustomerName) {
            <small [innerHTML]="projectLink.externalCustomerName | highlight:searchterm()"></small>
          }
          @if (projectLink.externalProjectNumber) {
            <small class="work-text-color-light"
                   [innerHTML]="'(' + projectLink.externalProjectNumber + ')' | highlight:searchterm()"></small>
          }
        </p>
      }
    }
    @if (project.status; as projectStatus) {
      <p>
        <small class="work-text-color-{{projectStatus.id | getProjectStatusColorVariantPipe}}">
          ({{ projectStatus.name }})
        </small>
      </p>
    }
  </div>
</ng-template>

<!--REUSABLE NG-TEMPLATES FOR BOTH VARIANTS: FOUND IN ... -->
<ng-template #foundInTemplate>
  <div class="flex flex-column">
    @for (property of contactAndProjects().foundInProperty; track $index) {
      @if (getPropertyValueFromEntity(property, contactAndProjects().contact)) {
        <small class="work-text-color-light">
          {{ property | translate }}:
          <span
            [innerHTML]="getPropertyValueFromEntity(property, contactAndProjects().contact) | highlight:searchterm()">
                </span>
        </small>
      }
    }
  </div>
</ng-template>

<!--REUSABLE NG-TEMPLATES FOR BOTH VARIANTS: CONTACT-->
<ng-template #contactResult let-contactFocused="contactFocused">
  <div>
    <div class="flex flex-row space-between gap-8 work-action-element"
         [class.disabled]="disableResultContactLinks()"
         (click)="contactClicked.emit({WorkContactAndProjectsResultDto: contactAndProjects()})"
         (keydown.enter)="contactClicked.emit({WorkContactAndProjectsResultDto: contactAndProjects()})"
         [routerLink]="renderContactAsLink() ? '/'+AppRoutePaths.KONTAKTE+'/'+AppRouteViewTypes.DETAILS+'/' + contactAndProjects().contact.id : undefined"
         tabindex="0">
      <div class="flex flex-row wrap vertical-center gap-8" [class.work-text-size-small]="!contactFocused">
        @if (contactAndProjects().contact.company) {
          <strong [innerHTML]="(contactAndProjects().contact.company | highlight:searchterm())"></strong>
        }
        @if (contactAndProjects().contact.firstName || contactAndProjects().contact.lastName) {
          <strong
            [innerHTML]="(contactAndProjects().contact | getFullnameOfContact:true) | highlight:searchterm()"></strong>
        }
      </div>
      @if (contactFocused) {
        <work-ui-badge [text]="contactAndProjects().contact.category?.name ?? ''" size="small" />
      }
    </div>
    @let hasAddress = contactAndProjects().contact.street || contactAndProjects().contact.zipcode || contactAndProjects().contact.city;
    @if (contactFocused && hasAddress) {
      <p class="work-text-color-light">
        <small>
          <span [innerHTML]="contactAndProjects().contact.street | highlight:searchterm()"></span>, <span
          [innerHTML]="contactAndProjects().contact.zipcode | highlight:searchterm()"></span>&nbsp;<span
          [innerHTML]="contactAndProjects().contact.city | highlight:searchterm()"></span>
        </small>
      </p>
    }
  </div>
</ng-template>
